export default __webpack_public_path__ + "static/hero-83c141683f7dddc78e54b86f0a9a4bfb.mp4";